import _ from "underscore";

import type { Breakdown } from "./index";

export function convertBreakdownToFilter<Type = any, B extends Breakdown<Type> = Breakdown<Type>>(breakdown: B, on?: boolean) {
  return _.mapObject(breakdown.all, (node) => {
    return {
      selected: on ? 1 as const : 0 as const,
      id: node[breakdown.config.id],
      parentId: node.parent?.[breakdown.config.id] || null,
      childIds: _(node.children).pluck(breakdown.config.id)
    };
  });
}

export default convertBreakdownToFilter;
